import { render, staticRenderFns } from "./previewImage.vue?vue&type=template&id=207145c4&scoped=true&"
import script from "./previewImage.vue?vue&type=script&lang=js&"
export * from "./previewImage.vue?vue&type=script&lang=js&"
import style0 from "./previewImage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./previewImage.vue?vue&type=style&index=1&id=207145c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207145c4",
  null
  
)

component.options.__file = "previewImage.vue"
export default component.exports